export default __webpack_public_path__ + "static/media/booked.5c145ac2.png";